import axios, {AxiosInstance, AxiosRequestConfig} from 'axios';
import {ILogService} from './Interfaces/ILogService';
import LogService from './LogService';
import {IMapService} from './Interfaces/IMapService';
import ApiService from './ApiService';
import {IApiService} from './Interfaces/IApiService';
import {LatLng} from '../Types/DtoTypes';

class MapService implements IMapService {
  logService: ILogService;
  apiService: IApiService;

  constructor() {
    this.logService = new LogService();
    this.apiService = new ApiService(() => {});
  }

  async getGeoCode(address: string) {
    let params = '?address=' + address;

    let config: AxiosRequestConfig = {};
    config.method = 'GET';
    config.url = process.env.REACT_APP_GEOCODE_URL + params;
    config.headers = {'Content-Type': 'application/json'};

    try {
      let response = await this.apiService.sendRequest<LatLng | null>(config);
      if (response?.data) {
        return {
          latitude: response?.data.latitude,
          longitude: response?.data.longitude,
        };
      }
    } catch (error) {
      await this.logService.sendLog(JSON.stringify(error));
    }

    return null;
  }
}

export default MapService;
